module.exports = __webpack_public_path__ + "static/media/iaction.b13799b9.svg";